var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuotationMarksBlue = function SvgQuotationMarksBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 43 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1053FF",
    d: "M8.857 18.042c.525-3.297 4.647-6.82 7.87-6.895.224 0 .45-.075.6-.225.15-.075.299-.15.374-.374 1.124-2.099.525-3.748-1.35-5.097-2.173-1.574-5.62 0-7.344 1.424C4.66 10.473.238 16.693.463 22.614c-.75 3.972-.6 8.244.525 11.767.75 2.248 2.923 3.372 5.171 3.522 2.249.15 6.895.825 8.919-.524 2.023-1.35 2.173-3.973 2.398-6.22.225-2.474.9-7.121-1.199-9.07-2.099-1.873-8.094.15-7.42-4.047zM33.59 18.042c.524-3.297 4.646-6.82 7.87-6.895.224 0 .449-.075.599-.225.15-.075.3-.15.375-.374 1.124-2.099.524-3.748-1.35-5.097-2.173-1.574-5.62 0-7.344 1.424-4.347 3.598-8.77 9.818-8.544 15.739-.75 3.972-.6 8.244.524 11.767.75 2.248 2.923 3.372 5.172 3.522 2.248.15 6.895.825 8.918-.524 2.024-1.35 2.174-3.973 2.399-6.22.225-2.474.9-7.121-1.2-9.07-2.098-1.873-8.169.15-7.42-4.047z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H43V43H0z"
  })))));
};
export default SvgQuotationMarksBlue;